import { useFeatureFlagVariantKey } from '@/features/flags/posthog-compat';

export const DICTATE_REENGAGEMENT_FLAG_KEY = 'exp-scribe-dictate-reengagement';
export const DICTATE_REENGAGEMENT_VIEW_EXPERIMENT_KEY = 'dictate-reengagement-view-v1';

export const DICTATE_REENGAGEMENT_HINT_VERSIONS = [
  'canvas_delayed_hint',
  'ask_heidi_mic_tooltip',
] as const;
export type DictateReengagementHintVersion =
  (typeof DICTATE_REENGAGEMENT_HINT_VERSIONS)[number];

export const useDictateReengagementFlag = (): {
  isEnabled: boolean;
  isResolved: boolean;
} => {
  const value = useFeatureFlagVariantKey(DICTATE_REENGAGEMENT_FLAG_KEY);
  if (value === undefined) return { isEnabled: false, isResolved: false };
  if (value === true) return { isEnabled: true, isResolved: true };
  if (value === false || value === 'control' || value === '')
    return { isEnabled: false, isResolved: true };
  return { isEnabled: true, isResolved: true };
};

export const useIsDictateReengagementEnabled = (): boolean =>
  useDictateReengagementFlag().isEnabled;
